<template>
  <form :class="$style.searchBar" @submit.prevent="onSearch">
    <div :class="$style.searchInput">
      <input :value="value" @input="onInput" :class="$style.searchInput_inner" :placeholder="placeholder" @focus="focused = true"
        @blur="focused = false" />
      <span v-if="showClear" :class="$style.searchInput_suffix">
        <i class="el-icon-circle-close"  @mousedown.prevent
            @click="clear" />
      </span>
      <div :class="$style.searchInput_append">
        <button :class="$style.submit" type="submit">
          <i class="el-icon-search" />
        </button>
      </div>
    </div>
  </form>
</template>

<script>
// import useSearch from "@/views/product/composables/useSearch.js";
import {
	computed,
	defineComponent,
	ref,
	useRoute,
	useRouter,
	watchEffect
} from "@nuxtjs/composition-api";
import { useVModel } from "@vueuse/core";
export default defineComponent({
	name: "SearchInput",
	props: {
		placeholder: {
			type: String,
			default: "搜索度假产品"
		},
		value: {
			type: String,
			default: ""
		}
	},
	emits: ["input", "search"],
	setup(props, { emit }) {
		const router = useRouter();
		const route = useRoute();
		const focused = ref(false);
		const nativeInputValue = computed(() => {
			return props.value === null || props.value === undefined
				? ""
				: String(props.value);
		});
		const showClear = computed(() => {
			return focused.value && nativeInputValue.value;
		});

		// const modelValue = useVModel(props, "value", emit, {
		// 	eventName: "input"
		// });

		const query = computed(() => {
			return route.value.query;
		});

		function onSearch() {
			emit("search", props.value);
			console.log(route.value.query, props.value);
		}

		function onInput(event) {
			emit("input", event.target.value);
		}

		function clear() {
			emit("input", '');
			emit('clear', '');
			emit("search", '');
		}
		return {
			focused,
			showClear,
			// modelValue,
			onInput,

			// keywords,
			// options,
			// searchType,
			// searchTypeLabel,
			clear,
			onSearch
		};
	}
	// data() {
	// 	return {
	// 		// focus: false,
	// 		showCatlog: false
	// 	};
	// },
	// computed: {
	// 	placeholder() {
	// 		const path = this.$route.path;
	// 		return path == "/resource/product/list/cruise"
	// 			? "搜索邮轮产品"
	// 			: "搜索度假产品";
	// 	}
	// },
	// methods: {
	// 	onSelect(option) {
	// 		this.searchType = option.value;
	// 		this.showCatlog = false;
	// 	}
	// }
});
</script>
<style lang="scss" module>
.searchBar {
  width: 21.125rem;
}
.searchInput {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(31, 33, 41, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
}
.searchInput_inner {
  border-radius: 0.5rem;
  height: 2.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 2.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: 100%;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.0565);
}
.searchInput_suffix {
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 2.5rem;
  position: absolute;
  right: 2.5rem;
  top: 0px;
}
.searchInput_append {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  position: absolute;
  right: 0px;
  top: 0px;
}
.submit {
  height: 2.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 2.5rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  width: 2.5rem;
}
</style>
